<template>
  <div>

    <!-- Welcome module mobile -->
    <transition name="fade">
      <div v-if="!welcomeDismissed" class="absolute pin-t pin-r pin-b pin-l z-40 bg-black30 md:hidden" @click="dismissWelcome">
      </div>
    </transition>
    <transition name="pop">
      <WelcomeModule
        v-if="!welcomeDismissed"
        class="absolute pin-t pin-l pin-b pin-r z-50 flex items-center justify-around pointer-events-none md:hidden"
        @add="addYourself"
        @close="dismissWelcome"
        @showRandom="showRandom"
      ></WelcomeModule>
    </transition>

    <!-- Welcome module desktop -->
    <WelcomeModule
      class="absolute pin-t pin-l w-2/5 max-w-sm z-50 ml-4 mt-4 hidden md:block"
      @add="addYourself"
      @close="dismissWelcome"
      @showRandom="showRandom"
    ></WelcomeModule>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WelcomeModule from "../components/WelcomeModule";

export default {
  name: "welcome",
  components: { WelcomeModule },
  computed: {
    ...mapGetters(["currentState", "welcomeDismissed"])
  },
  methods: {
    dismissWelcome() {
      this.$store.commit("dismissWelcome");
    },
    showRandom() {
      this.dismissWelcome();
      this.$emit("showRandom");
    },
    addYourself() {
      this.$store.commit("dismissWelcome");
      this.$router.push({ name: "add-point" });
    }
  }
};
</script>




// WEBPACK FOOTER //
// WelcomeView.vue?524b2826